import NavLink from 'src/components/navigation/NavLink';
import { NavigationMenuItem, NavigationMenuLink } from 'src/registry/ui/NavigationMenu';
import { cn } from 'src/utils';

type TabProps = {
    to: string;
    label?: string;
    children?: React.ReactNode;
    end?: boolean;
};

const Tab = ({ to, label, children, end }: TabProps) => {
    return (
        <NavigationMenuItem>
            <NavigationMenuLink asChild>
                <NavLink
                    to={to}
                    end={end}
                    routerClassName={({ isActive }) =>
                        cn(
                            'flex shrink-0 text-nowrap items-center justify-center rounded-md px-3 py-2 text-sm font-medium text-gray-500 transition-colors hover:bg-gray-200 hover:text-gray-900',
                            isActive && 'pointer-events-none bg-white text-primary-700 shadow-xs hover:bg-primary-100',
                        )
                    }
                >
                    {label ?? children}
                </NavLink>
            </NavigationMenuLink>
        </NavigationMenuItem>
    );
};

export default Tab;
